export enum LocalStorageKeys {
    ExpirationTime = 'exp',
    AuthenticationCode = 'auth',
    SnapshotTour = 'snapshotTour',
    ExplorationTour = 'explorationTour',
    TargetingTour = 'targetingTour',
    RetargetingTour = 'retargetingTour',
    showDemographics = 'showDemographics',
    allowPubmatic = 'allowPubmatic',
    allowOneTag = 'allowOneTag',
    maintenanceMode = 'maintenance',
    LogoutEvent = 'logout-event',
    LoginEvent = 'login-event',
    useClickHouse = 'useClickHouse',
    allowDemoFeatures = 'allowDemoFeatures',
    campaigns = 'campaigns',
    isSidebarClosed = 'isSidebarClosed',
    CloneSegmentJSON = 'cloneSegmentJSON',
    GeoM = 'geom'
}
